import React, { useState } from "react";
import ReactEcharts from "echarts-for-react";


const BarchartDay = (props) => {

  const symbol = props.symbol || ''; 


  const getOptions = () => ({
    xAxis: {
      data: props.valuesX
      ,
      axisLabel: {
        rotate: 30, 
        interval: 0, 
        textStyle: {
          fontSize: 12, 
          color: '#333', 
        }
      }
    },
    yAxis: {},
    title: {
      text: props.title,
      subtext: props.subTitle,
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    grid: {
      top: '22%', // Espacio superior
      left: '10%', // Espacio izquierdo
      right: '10%', // Espacio derecho
      bottom: '30%', // Aumenta este valor para dar más espacio en la parte inferior
    },
    series: [
      {
        label: {
          show: props.showSerieValue,
          position: 'top' ,
          formatter: (params) => {
            return new Intl.NumberFormat('es-CO', {
              minimumFractionDigits: props.decimals||0, // Mínimo de decimales
              maximumFractionDigits: props.decimals||0, // Máximo de decimales
            }).format(params.value)+symbol;
          }
        },
        type: "bar",
        data: props.valuesY,
      },
    ],
  });
  return (
    <div className="">
      <ReactEcharts
        ref={props.chartRef}
        option={getOptions()}
        style={{ height: 300 }}
      />
    </div>
  );
}


export default BarchartDay
